module.exports = __webpack_public_path__ + "static/media/friendship.841d19cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/friendship.png
// module id = 846
// module chunks = 0